(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-mixed-recommendations"] && !Shopify.designMode) return;
  try {
    
  class CartMixedRecommendations extends HTMLElement {
    constructor() {
      super();
      this.hasLoaded = false;
    }

    connectedCallback() {
      if (this.hasLoaded) return;

      const observer = new IntersectionObserver(
        (entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.unobserve(this);
          this.hasLoaded = true;
          this.loadRecommendations();
        },
        { rootMargin: '0px 0px 200px 0px' }
      );

      observer.observe(this);
    }

    async loadRecommendations() {
      try {
        const grid = this.querySelector('[data-grid]');
        if (!grid) return;

        const cart = await fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json());

        const totalSlots = Math.max(1, parseInt(this.dataset.limit || '6', 10));
        const maxDrivers = Math.max(1, parseInt(this.dataset.maxDrivers || '6', 10));
        const intent = this.dataset.intent || 'related';
        const sectionId = this.dataset.sectionId;

        const cartProductIds = [];
        const cartProductUrls = new Set();

        (cart.items || []).forEach((item) => {
          if (item.url) {
            cartProductUrls.add(this.normalizeUrl(item.url));
          }

          if (item.product_id && !cartProductIds.includes(item.product_id) && cartProductIds.length < maxDrivers) {
            cartProductIds.push(item.product_id);
          }
        });

        if (!cartProductIds.length) {
          this.style.display = 'none';
          return;
        }

        const desktopColumns = Math.min(totalSlots, 6);
        grid.style.setProperty('--desktop-columns', String(desktopColumns));

        const allocations = this.allocateSlots(totalSlots, cartProductIds.length);

        const responses = await Promise.all(
          cartProductIds.map((productId, index) => {
            const fetchLimit = Math.min(10, Math.max(allocations[index] + 6, 6));
            const url =
              window.Shopify.routes.root +
              'recommendations/products' +
              '?product_id=' + encodeURIComponent(productId) +
              '&section_id=' + encodeURIComponent(sectionId) +
              '&limit=' + encodeURIComponent(fetchLimit) +
              '&intent=' + encodeURIComponent(intent);

            return fetch(url)
              .then((response) => response.text())
              .then((text) => ({ productId, text }))
              .catch((error) => {
                console.error('Recommendation fetch failed for product:', productId, error);
                return { productId, text: '' };
              });
          })
        );

        const buckets = [];

        responses.forEach((response) => {
          if (!response.text) {
            buckets.push([]);
            return;
          }

          const html = document.createElement('div');
          html.innerHTML = response.text;

          const sourceRoot =
            html.querySelector('.cart-mixed-recommendations-source') ||
            html.querySelector('product-recommendations') ||
            html;

          const productCards = this.extractProductCards(sourceRoot);
          buckets.push(productCards);
        });

        const selectedItems = [];
        const selectedUrls = new Set([...cartProductUrls]);

        for (let i = 0; i < buckets.length; i += 1) {
          const wanted = allocations[i];
          if (!wanted) continue;

          const chosen = this.takeUniqueItems(buckets[i], wanted, selectedUrls);
          selectedItems.push(...chosen);
        }

        if (selectedItems.length < totalSlots) {
          const leftovers = buckets.flat();
          const extras = this.takeUniqueItems(leftovers, totalSlots - selectedItems.length, selectedUrls);
          selectedItems.push(...extras);
        }

        if (!selectedItems.length) {
          this.style.display = 'none';
          return;
        }

        grid.innerHTML = '';

        selectedItems.forEach((item) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'cart-mixed-recommendations__item';
          wrapper.innerHTML = item.innerHTML;
          grid.appendChild(wrapper);
        });
      } catch (error) {
        console.error('Cart mixed recommendations failed:', error);
        this.style.display = 'none';
      }
    }

    allocateSlots(totalSlots, driverCount) {
      const allocations = new Array(driverCount).fill(0);
      const base = Math.floor(totalSlots / driverCount);
      let remainder = totalSlots % driverCount;

      for (let i = 0; i < driverCount; i += 1) {
        allocations[i] = base + (remainder > 0 ? 1 : 0);
        if (remainder > 0) remainder -= 1;
      }

      return allocations;
    }

    extractProductCards(root) {
      const links = Array.from(root.querySelectorAll('a[href*="/products/"]'));
      const seen = new Set();
      const cards = [];

      links.forEach((link) => {
        const url = this.normalizeUrl(link.getAttribute('href'));
        if (!url || seen.has(url)) return;

        const card = this.findCardElement(link);
        if (!card) return;

        seen.add(url);
        cards.push(card);
      });

      return cards;
    }

    findCardElement(link) {
      const selectors = [
        '.grid__item',
        '.swiper-slide',
        'li',
        'article',
        '.card',
        '.product-card',
        '.collection-product-card',
        '[class*="product-card"]',
        '[class*="card"]'
      ];

      for (const selector of selectors) {
        const match = link.closest(selector);
        if (match) return match;
      }

      return link.parentElement;
    }

    takeUniqueItems(items, wanted, selectedUrls) {
      const chosen = [];

      for (const item of items) {
        if (chosen.length >= wanted) break;

        const productUrl = this.extractProductUrl(item);
        if (!productUrl) continue;
        if (selectedUrls.has(productUrl)) continue;

        selectedUrls.add(productUrl);
        chosen.push(item);
      }

      return chosen;
    }

    extractProductUrl(item) {
      const link = item.querySelector('a[href*="/products/"]');
      if (!link) return null;
      return this.normalizeUrl(link.getAttribute('href'));
    }

    normalizeUrl(url) {
      try {
        const absolute = new URL(url, window.location.origin);
        return absolute.pathname.replace(/\/+$/, '');
      } catch (error) {
        return (url || '').split('?')[0].replace(/\/+$/, '');
      }
    }
  }

  if (!customElements.get('cart-mixed-recommendations')) {
    customElements.define('cart-mixed-recommendations', CartMixedRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
